<template>
  <div class="flex_column_horizontally_center" style="width: 75rem">
    <div class="flex_row">
      <el-carousel style="width: 41.875rem;" height="29.375rem">
        <el-carousel-item v-for="item in topCarouselList" :key="item.id">
          <div style="position: relative;" v-on:click="articleJumpTo(item)">
            <el-image style="width: 41.875rem;height: 29.375rem;position: absolute;left: 0;top: 0;cursor: pointer"
                      :src="item.imgUrl" fit="fill"/>
            <div class="cover_font font_auto_hidden"
                 style="position: absolute;top: 26.875rem;left: 1.25rem;cursor: pointer;width: 38.75rem">
              {{ item.title }}
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>

      <div class="flex_column"
           style="width: 31.25rem;height: 30rem;justify-content: space-between;margin-left: 2rem;">
        <div class="flex_row_vertical_center" v-for="item in topTextList" :key="item.id">
          <div style="background: #0098FE;width: 0.3125rem;height: 0.4375rem"></div>
          <div class="title_font font_auto_hidden" style="cursor: pointer" v-on:click="articleJumpTo(item)">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <div class="flex_row_horizontally_vertical_center" style="width: 100vw;margin-top: 30px;margin-bottom: 10px;">
      <el-image src="join_us_bar.png" style="width: 75rem;cursor: pointer;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);;" v-on:click="jumpTo('https://www.wjx.top/vm/rQB87gu.aspx# ')"></el-image>
    </div>

    <FiveAboutUser style="width: 830px"> </FiveAboutUser>

    <div class="flex_row" style="justify-content: space-between;width: 75rem;margin-top: 40px;margin-bottom: 40px">
      <el-image style="width: 211px;height: 111px;cursor: pointer;"
                :src="item.imgUrl" fit="fill" v-for="item in topOtherList" :key="item.id" v-on:click="jumpTo(item.to)"/>
    </div>
    <div class="flex_row_horizontally_vertical_center" style="background:#f7f9fc;width: 100vw;height: 476px;">
      <div class="flex_row_vertical_center" style="width: 75rem;justify-content: space-between;">
        <el-card style="width: 384px;height: 356px;" v-for="item in middleCardList" :key="item.id">
          <div class="flex_column_vertical_center" style="padding-top: 10px">
            <div class="flex_row_vertical_center">
              <el-image :style="item.style" :src="item.imgUrl"></el-image>
              <div class="card_title" style="margin-left: 8px" v-on:click="bottomJumpTo( item.title)">{{
                  item.title
                }}
              </div>
            </div>
            <div class="card_content" style="margin-top: 10px;min-height: 130px">
              {{ item.content }}
            </div>
            <div style="height: 0.0625rem;width: 100%;background: #DFEBF6;margin-top: 0px;margin-bottom: 1.25rem"></div>
            <div class="flex_column" style="height:96px;width: 100%;justify-content: space-between;">
              <div class="flex_row_vertical_center" v-for="textItem in item.textList" :key="textItem.id"
                   :name="textItem.id">
                <div style="background: #0098FE;width: 0.3125rem;height: 0.4375rem"></div>
                <div class="card_bottom font_auto_hidden" v-on:click="articleJumpTo(textItem)">{{
                    textItem.title
                  }}
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <div class="flex_column_horizontally_center" style="margin-top: 50px;margin-bottom: 50px">
      <div class="middle_vip_font" style="cursor: pointer;margin-bottom: 40px">会员风采</div>
      <MainBottomCarousel :data-list="middleCarouselList"></MainBottomCarousel>
    </div>


    <div class="flex_row_horizontally_vertical_center" style="background:#f7f9fc;width: 100vw;height: 416px;">
      <div class="flex_row_vertical_center" style="width: 75rem;justify-content: space-between;">
        <el-card style="width: 579px;height: 296px;" v-for="item in bottomCardList" :key="item.id">
          <div class="flex_column_vertical_center" style="padding-top: 10px">
            <div class="flex_row_vertical_center">
              <el-image :style="item.style" :src="item.imgUrl"></el-image>
              <div class="card_title" style="margin-left: 8px" v-on:click="bottomJumpTo( item.title)">{{
                  item.title
                }}
              </div>
            </div>
            <div class="card_content" style="margin-top: 10px;min-height: 60px">
              {{ item.content }}
            </div>
            <div style="height: 0.0625rem;width: 100%;background: #DFEBF6;margin-top: 0px;margin-bottom: 1.25rem"></div>
            <div class="flex_column" style="height:96px;width: 100%;justify-content: space-between;">
              <div class="flex_row_vertical_center" v-for="textItem in item.textList" :key="textItem.id"
                   :name="textItem.id">
                <div style="background: #0098FE;width: 0.3125rem;height: 0.4375rem"></div>
                <div class="card_bottom font_auto_hidden" v-on:click="articleJumpTo(textItem)">{{
                    textItem.title
                  }}
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <div class="flex_column_horizontally_center" style="margin-top: 50px;margin-bottom: 50px">
      <div class="middle_vip_font" style="cursor: pointer;margin-bottom: 40px">精彩视频</div>
      <div class="flex_row" style="justify-content: space-between">
        <VideoListItem :data-detail="item" v-for="item in bottomCarouselList" :key="item.id"
                       style="margin-left: 17px;margin-right: 17px;"></VideoListItem>
      </div>
    </div>
    <div class="flex_column_horizontally_vertical_center" style="background:#f7f9fc;width: 100vw;height: 383px;">
      <div class="bottom_text1">资料</div>
      <div class="flex_row_horizontally_center" style="width: 100%;margin-top: 1.25rem;margin-bottom: 38px;">
        <el-input style="width: 30rem;height: 40px;" placeholder="请输入关键字"></el-input>
        <el-select
            v-model="selectorNowValue"
            placeholder="请选择"
            size="large"
            style="width: 250px;height: 40px;margin-left: 10px">
          <el-option
              v-for="item in bottomSearchList"
              :key="item.style"
              :label="item.style"
              :value="item.title"/>
        </el-select>
        <el-button type="primary" style="width: 68px;height: 40px;margin-left: 10px">搜索</el-button>

      </div>
      <div class="flex_row_vertical_center" style="justify-content: space-between">
        <div class="bottom_card flex_column_horizontally_vertical_center" style="cursor: pointer"
             v-for="item in bottomSearchList"
             @mouseenter="item.hover=true" @mouseleave="item.hover=false" v-on:click="bottomJumpTo( item.title)">
          <el-image :style="item.style" :src="item.hover?item.hoverImgUrl:item.imgUrl"></el-image>
          <div style="font-size: 18px;margin-top: 10px">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import MainBottomCarousel from "@/components/MainBottomCarousel.vue";
import VideoListItem from "@/components/VideoListItem.vue";
import FiveAboutUser from "@/components/FiveAboutUser.vue";


export default {
  name: 'HomeView',
  components: {
    FiveAboutUser,
    VideoListItem,
    MainBottomCarousel,
  },
  data() {
    return {
      topCarouselList: this.$initData.initArticleList(5),
      middleCarouselList: this.$initData.initArticleList(7),
      bottomCarouselList: this.$initData.initArticleList(4),
      topTextList: this.$initData.initArticleList(8),
      topOtherList: this.$initData.initOtherList(),
      middleCardList: this.$initData.initMainPageMiddleCardList(),
      bottomCardList: this.$initData.initMainPageBottomCardList(),
      bottomSearchList: this.$initData.initMainPageBottomSearchList(),
      selectorNowValue: ""
    }
  },
  methods: {
    jumpTo(item) {
      window.open(item)
    },
    articleJumpTo(item) {
      console.log(item)
      if (item.toUrl !== "") {
        this.jumpTo(item.toUrl)
      } else {
        this.$router.push("/article_detail?article_id=" + item.id)
      }
    },
    bottomJumpTo(item) {
      if (item === "品牌活动") {
        this.$router.push("/article_next?breadcrumb_type=news4")
      }
      if (item === "专业服务") {
        this.$router.push("/article_next?breadcrumb_type=news5")
      }
      if (item === "公益行动") {
        this.$router.push("/article_next?breadcrumb_type=news6")
      }
      if (item === "分支机构") {
        this.$router.push("/affiliated_agency")
      }
      if (item === "各地协会") {
        this.$router.push("/other_association")
      }
      if (item === "研究报告") {
        this.$router.push("/article_next?breadcrumb_type=information1")
      }
      if (item === "社会责任报告") {
        this.$router.push("/article_next?breadcrumb_type=information2")
      }
      if (item === "政策法规") {
        this.$router.push("/article_next?breadcrumb_type=information3")
      }
      if (item === "政策解读") {
        this.$router.push("/article_next?breadcrumb_type=information4")
      }

    }
  }
}
</script>

<style scoped>

.cover_font {
  text-shadow: 2px 2px 2px #000000;
  color: #fff;
  font-weight: 300;
  font-size: 18px;
}

.title_font {
  font: 14px / 1.5 "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "WenQuanYi Micro Hei", "Microsoft Yahei", sans-serif;
  color: #000000;
  font-weight: 300;
  font-size: 18px;
  line-height: 30px;
  margin-left: 10px;
  margin-bottom: 15px;
  margin-top: 15px;
  transition: .8s;
}

.title_font:hover {
  color: #0098FE;
  text-decoration: underline;
}

.card_title {
  font-size: 24px;
  line-height: 36px;
  color: #333;
  font-weight: normal;
  transition: .8s;
  cursor: pointer;
}

.card_title:hover {
  color: #0098FE;
}

.card_content {
  font-size: 14px;
  line-height: 30px;
  color: #666;
  text-align: left;
}

.card_bottom {
  font-size: 14px;
  margin-left: 10px;
  cursor: pointer;
}

.bottom_text1 {
  font-size: 30px;
  text-align: center;
  font-weight: normal;
  letter-spacing: 2px;
}

.bottom_card {
  width: 284px;
  height: 118px;
  border: 0.0625rem solid #d1d1d1;
  margin-left: 0.3125rem;
  margin-right: 0.3125rem;
  transition: .4s;
}

.bottom_card:hover {
  border: 0.0625rem solid #5092DE;
  background-color: #5092DE;
  color: #fff;
}

.middle_vip_font {
  font-size: 30px;
  text-align: center;
  font-weight: normal;
  letter-spacing: 2px;
  transition: .8s;
}

.middle_vip_font:hover {
  color: #0098FE;
}

</style>
